import { FiscalDataUi } from '@/components/Buyer/BuyerProfile/PaymentAndFiscalData/FiscalData/FiscalDataUi';
import { UpdateBuyerFiscalDataRequest } from '@/data/api/model/buyers/BuyersDto';

export const fiscalDataUiToUpdateBuyerFiscalDataRequest = (
  input: FiscalDataUi
): UpdateBuyerFiscalDataRequest => ({
  require_invoice: input.taxInvoiceRequired,
  legal_name: input.legalName,
  tax_id: input.rfc,
  cfdi_use_id: input.cfdiUse,
  tax_regime_id: input.fiscalRegime,
  email: input.taxEmail,
  zip_code: input.postalCode,
});

export const requireFiscalDataToUpdateBuyerFiscalDataRequest = (
  requireFiscalData: boolean
): UpdateBuyerFiscalDataRequest => ({
  require_invoice: requireFiscalData,
});
